/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, Path, Polyline, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function NyTimesLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle cx={172} cy={148} r={10} />
      <Path
        d="M205.57177,163.35784A80.00853,80.00853,0,1,1,127.92969,64"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Path
        d="M67.24858,91.86653A28.00107,28.00107,0,0,1,70,36L186,92a28,28,0,0,0,0-56"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Polyline
        points="48.589 154.315 127.93 112 127.93 224"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Line
        x1={95.92969}
        y1={129.06667}
        x2={95.92969}
        y2={217.34317}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
    </Svg>
  );
}

export default NyTimesLogo;
